export enum EBannerType {
    IMAGE = 'image',
    VIDEO = 'video',
    VIDEO_UPLOAD = 'video_upload'
}
